module.exports = __webpack_public_path__ + "img/magento-version-switching_small.6254d1a7.webp";